import Box from '@mui/material/Box';
import { FC } from 'react';
import { useStyles } from '../../theme/styles.helpers';
import { TypeBadgeStyles } from './TypeBadge.Styles';

export type TypeBadgeVariant = 'rezept' | 'befundung';

interface TypeBadgeProps {
  variant: TypeBadgeVariant;
}

export const TypeBadge: FC<TypeBadgeProps> = ({ variant }) => {
  const styles = useStyles(TypeBadgeStyles, { variant });
  return <Box sx={styles.badge}>{variant === 'rezept' ? '💊 Rezept' : '🧪 Befundung'}</Box>;
};
